import { defineStore } from 'pinia'
import {services, getHeader } from '@/assets/js/config.js'
import axios from 'axios'

export const useLeadStore = defineStore('leadStore', {
  state:() => ({
    current_lead: null,
    current_lead_logs: [],
    listing_current_page: 1,
    filter_query: {},
		checkReassignmentRun: false,
		checkReassignmentTry: 0
  }),
    actions : {
        resetLeadStore(){
            this.current_lead = null
            this.current_lead_logs = []
        },
        currentPageChanged(page){
            this.listing_current_page = page
        },
        setFilterQuery(queryString){
            this.filter_query = queryString
            this.listing_current_page = 1
        },
				async getPrevLeads(contact_no,created_at) {
					try{
						const res = await axios.get(services.lead + 'leads', {
								params: {
									contact_no: contact_no,
									created_at: '0,'+created_at
								},
								headers: getHeader()
							});
						return (!_gHlp.isEmpty(res.data.data) && !_gHlp.isEmpty(res.data.data.data)) ? res.data.data.data : [];
					}catch(e){
						return [];
					}	
				},
        async getLead(id){
            try{
                const res = await axios.get(services.lead + 'leads/' + id, {headers: getHeader()})
                this.current_lead = res.data.data
            }catch(e){
                this.current_lead = null
                console.log('Lead Store (getLead) failed:' + e.response.data.message)
            }
        },
				async createLead(params){
					try{
						const response = await axios.post(services.lead + 'leads', params, { headers: getHeader()})
						return response;
					}catch(e){
						return [];	
					}
				},
				async updateLead(id,params){
					try{
						const res = await axios.put(services.lead + 'leads/'+id, params, { headers: getHeader()})
						return _gHlp.getValue(res,'data.data');
					}catch(e){
						return [];	
					}
				},
				async deleteLead(id){
					try{
						const response = await axios.delete(services.lead + 'leads/'+id, { headers: getHeader()})
						return response;
					}catch(e){
						return [];	
					}
				},
        async getLeadActivityLog(id, date_picked = null){
            try{
                let query = ''
                if(date_picked){
                    query = '?date=' + date_picked
                }
                const res = await axios.get(services.lead + 'lead/' + id + '/activity_logs' + query, { headers: getHeader() })
                this.current_lead_logs = res.data.data
            }catch(e){
                this.current_lead_logs = []
                console.log('Lead Store (getLeadActivityLog) failed:' + e.response.data.message)
            }
				},
				async getApptStatusLog(id){
            try{
							const res = await axios.get(services.lead + 'appointment-status-log/' + id, { headers: getHeader() })
							return res.data.data
            }catch(e){
							return []
            }
        },
				getLeadReassignments(){
					this.advisoryStatusList  = [];
					return new Promise((resolve, reject) => {
						axios.get(services.lead + 'lead/reassignments', { headers: getHeader() }).then((resp) => {
							resolve(_gHlp.getValue(resp,'data.data.data',[]))
						}).catch(err => {
							reject(err)
						})
					})  
				},
				async runLeadReassgnments(){
					try{
						await axios.post(services.lead + 'lead/reassignment',{},{ headers: getHeader() })
						return true
					}catch(e){
						_gNotif.errorFunction(e)
						return false
					}
				},
				async checkReassignment(){
					if(this.checkReassignmentTry < 5 && this.checkReassignmentRun ){
						setTimeout(() => {
							axios.get(services.lead + 'lead/reassignments', { headers: getHeader() })
								.then(res => {
									if(!_gHlp.isEmpty(res.data.data.data) && res.data.data.data.length > 0){
										let tableData = res.data.data.data[0];
										if(tableData.process_status == "COMPLETED"){
											this.checkReassignmentRun = false;
											this.checkReassignmentTry = 0;
											_gNotif.notifySuccess('<b>Status </b> - Reassign process has been finish please check result on leads listing page');
										}else{
											this.checkReassignment();
											this.checkReassignmentTry++
										}
									}else{
										this.checkReassignmentRun = false;
										this.checkReassignmentTry = 0;
									}	
								})
								.catch(e => {
									this.checkReassignmentRun = false;
									this.checkReassignmentTry = 0;
									_gNotif.errorFunction(e)
								})
						}, 2000);
					}else{
						this.checkReassignmentRun = false;
						this.checkReassignmentTry = 0;
					}
				},
				checkIsOwnLead(lead){
					const actvUser = _gAuth.activeUser();
					if(_gHlp.isEmpty(actvUser)) return false;
					//if curent user is current assigned user
					if(lead.assign_to == actvUser.id) return true;

					//if no assigned user
					if(_gHlp.isEmpty(lead.lead_assignments)) return false;

					//if curent user is has assigned before
					const hasAssign = lead.lead_assignments.find(
										item => item.user_id == actvUser.id
								);

					if(!_gHlp.isEmpty(hasAssign)) return true;

					return false;
				},
				getRealStatusSummary(lead){
					const actvUser = _gAuth.activeUser();
					const hasAssign = lead.lead_assignments.find(
                    item => item.user_id == actvUser.id
                );
					if(_gHlp.isEmpty(hasAssign)){
						if(!_gHlp.isEmpty(lead.assign_to)){
							const currAssign = lead.lead_assignments.find(
									item => item.user_id == lead.assign_to
							);
							if(!_gHlp.isEmpty(currAssign)){
								return currAssign.status_detail;
							}
						}
						return lead.status_detail;
					} 

					return hasAssign.status_detail;
				},
				getRealAssignAt(lead){
					const actvUser = _gAuth.activeUser();
					const hasAssign = lead.lead_assignments.find(
										item => item.user_id == actvUser.id
								);

					if(_gHlp.isEmpty(hasAssign)){
						if(!_gHlp.isEmpty(lead.assign_to)){
							const currAssign = lead.lead_assignments.find(
									item => item.user_id == lead.assign_to
							);
							if(!_gHlp.isEmpty(currAssign)){
								return currAssign.reassignment_at;
							}
						}
						return lead.reassignment_at;
					} 			

					return hasAssign.assign_at;
				},
        getRealAppointmentAt(lead) {
            const actvUser = _gAuth.activeUser();
            const hasAssign = lead.lead_assignments.find(
                item => item.user_id == actvUser.id
            );
						if(_gHlp.isEmpty(hasAssign)){
							if(!_gHlp.isEmpty(lead.assign_to)){
								const currAssign = lead.lead_assignments.find(
										item => item.user_id == lead.assign_to
								);
								if(!_gHlp.isEmpty(currAssign)){
									return currAssign.appointment_at;
								}
							}
							return lead.appointment_at;
						} 
            
            return hasAssign.appointment_at;
        },
        getRealAppointmentHistory(lead) {
            const actvUser = _gAuth.activeUser();
            const hasAssign = lead.lead_assignments.find(
                item => item.user_id == actvUser.id
            );
						if(_gHlp.isEmpty(hasAssign)){
							if(!_gHlp.isEmpty(lead.assign_to)){
								const currAssign = lead.lead_assignments.find(
										item => item.user_id == lead.assign_to
								);
								if(!_gHlp.isEmpty(currAssign)){
									return currAssign.appointment_history;
								}
							}
							return lead.appointment_history;
						}

            return hasAssign.appointment_history;
        },
				getRealMessageAt(lead){
					const actvUser = _gAuth.activeUser();
					const hasAssign = lead.lead_assignments.find(
										item => item.user_id == actvUser.id
								);
					
					if(_gHlp.isEmpty(hasAssign)){
						if(!_gHlp.isEmpty(lead.assign_to)){
							const currAssign = lead.lead_assignments.find(
									item => item.user_id == lead.assign_to
							);
							if(!_gHlp.isEmpty(currAssign)){
								return currAssign.last_message_at;
							}
						}
						return lead.last_message_at;
					}
					
					return hasAssign.last_message_at;
				},
				getRealMessageBundle(lead){
					const actvUser = _gAuth.activeUser();
					const hasAssign = lead.lead_assignments.find(
                    item => item.user_id == actvUser.id
                );
					
					if(_gHlp.isEmpty(hasAssign)){
						if(!_gHlp.isEmpty(lead.assign_to)){
							const currAssign = lead.lead_assignments.find(
									item => item.user_id == lead.assign_to
							);
							if(!_gHlp.isEmpty(currAssign)){
								return currAssign.message_group_bundle_key;
							}
						}
						return lead.message_group_bundle_key;
					}			
					
					return hasAssign.message_group_bundle_key;
				},
				async getUserCanAccess(id){
					try {
						const res = await axios.get(services.lead + 'get-user-can-access-list/' + id, { headers: getHeader() });
						return res.data.data
					} catch (e) {
						// this.errorFunction(e)
						console.log('getUserCanAccess failed:' + e)
						return []
					}
        },
				getPartialLeads(filters, trype){
					return new Promise((resolve, reject) => {
						let params = _gHlp.generateQueryParams({...filters,...{ver:2,resp:trype}});
						axios.get(services.lead + 'leads?' + params, {headers: getHeader()}).then((resp) => {
							resolve(_gHlp.getValue(resp,'data.data'));
						}).catch(e => {
							reject(e);
						})
					});
				}
    }
})